// import conf from '../../../config/vue/config.js';
import $ from 'jquery';
// import * as Sentry from '@sentry/browser';
import { asyncScheduler } from 'rxjs';
import axios from 'axios';
import Cookies from 'js-cookie'

/* eslint-disable */

/*
 * digitaltwins-service#622 (from #619's review): the keycloak-js adapter and its
 * `flow: 'implicit'` init are gone. Sign-in is the server's authorization code flow
 * (/auth/login, #480); the page learns who is signed in from /auth/user. `keycloak`
 * only holds the access token read from the `token` cookie, for the callers below and
 * the modules that import `dttKeyCloak`.
 */
var keycloak: { token?: string } = {};


export const dttKeyCloak = keycloak;
async function getCurrentUser() {
	return await (axios.get("/auth/user").then(usr=>{
		// var x=Cookies;
		var token=Cookies.get("token");
		keycloak.token=token;
		// debugger;
		return Object.assign(usr.data,{token:token});
	}).catch(e=>{
		if (e.response && e.response.status==401) {
			// var url=new URL(location.href);
			// debugger;
			if (typeof((window as any).isPublicReplay)=="undefined") {
				location.reload();
			}
			
			// debugger;
		}
	
		return false;
	}))
}
export const keycloakInit=getCurrentUser();
function logout() {
	location.href="/auth/logout"
	// keycloak.logout()
}


pcGatewayShowUsername();
function pcGatewayShowUsername() {
	keycloakInit.then(function (usr) {
		if (usr) {
			// var username = keycloak.idTokenParsed.preferred_username;
			var username=usr.preferred_username;
			sessionStorage.setItem("USERNAME", username)
			sessionStorage.setItem("token", keycloak.token)
			// var objShow = document.getElementById("usernamelogin");
			// if(objShow){
			$("#usernamelogin").html(username);
		} else {
			sessionStorage.removeItem("USERNAME")
			sessionStorage.removeItem("token")
			// debugger;
		}
		
		// }
	});
}
export function callFunctionV2<T>(url: string, method: any, jsonRequest: any):Promise<T> {
	// console.log("callFunction URL:"+url);
	return new Promise<T>((resolve, reject) => {
		keycloakInit.then(function (authenticated) {
			var token = keycloak.token;

			// console.log("token:"+token);
			//call function 
			// console.log("callFunctionV2 URL:"+url);
			// debugger;
			if (authenticated && token) {

				$.ajax({
					type: method,
					url: url,
					contentType: "application/json; charset=utf-8;",
					headers: {

						"Content-Type": "application/x-www-form-urlencoded",
						"Authorization": "Bearer " + token
					},
					data: {
						"jsonRequest": jsonRequest
					},
					success: function (response: T | PromiseLike<T>) {
						resolve(response)
					},
					error: function (request: any, status: any, error: any) {
						reject(error);
					}
				});
			} else {
				throw new Error("Unauthorize on calling: " + url);
			}
		}).catch((e) => {
			// Sentry.captureException(e);
			return Promise.reject(e);
		});
	})



}


export function callFunction(url: string, method: string, jsonRequest: string, func: Function) {
	// console.log("callFunction URL:"+url);
	return new Promise<any>((resolve, reject) => {
		keycloakInit.then(function (authenticated) {
			var token = keycloak.token;

			// console.log("token:"+token);
			//call function 
			if (authenticated && token) {

				$.ajax({
					type: method,
					url: url,
					contentType: "application/json; charset=utf-8;",
					headers: {

						"Content-Type": "application/x-www-form-urlencoded",
						"Authorization": "Bearer " + token
					},
					data: {
						"jsonRequest": jsonRequest
					},
					success: function (response: any) {
						resolve({ data: response })
						// console.log('data1: '+response)          
						if (func) {
							func(response);
						}

					},
					error: function (request: any, status: any, error: any) {
						reject(error);

					}
				});
			} else {
				reject(new Error("Unauthorize on calling: " + url))
			}
		}).catch(function (e) {
			// Sentry.captureException(e);
			resolve(undefined)
			console.error(e);
		});
	})



}

export function callFunctionByToken(url: string, method: string, token: string,
	jsonRequest: any, func: Function) {
	console.log("callFunctionByToken with url:" + url + ",token:" + token);
	console.log(jsonRequest);
	$.ajax({
		type: method,
		url: url,
		dataType: 'json',
		contentType: "application/json; charset=utf-8;",
		headers: {
			"Content-Type": "application/json",
			"Authorization": "Bearer " + token
		},
		data: JSON.stringify(jsonRequest),

		success: function (response: any) {
			func(response);
		}
	});

}

export { logout }

export default callFunction

